import React from "react";
import { CheckCircle, Building2, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
    "Ferris-wheel style vertical rotation of vehicles",
    "Requires minimal ground space — ideal for tight plots",
    "Fully automatic operation with fast car retrieval",
    "Energy-efficient and low operational cost",
    "High durability with robust safety systems",
];

const applications = [
    "Standalone Commercial Plots",
    "Narrow Urban Corners",
    "Police Stations & Municipal Parking",
    "Auto Dealerships with Limited Display Space",
    "Bungalows or Apartments with Small Front Area",
];

const RotaryParkingDetail = () => {
    const navigate = useNavigate()
    return (
        <section className="about-wrapper">
            {/* Hero */}
            <div className="about-hero">
                <div className="hero-content">
                    <h1>Rotary Parking System</h1>
                    <p>
                        A smart, space-saving vertical parking system that rotates cars like a Ferris wheel — ideal for congested areas and narrow plots where every square foot matters.
                    </p>
                </div>
            </div>

            {/* Description */}
            <div className="about-section">
                <h2>What is Rotary Parking?</h2>
                <p>
                    Rotary Parking is a fully automated system that vertically rotates a steel frame holding multiple cars, similar to a giant wheel. It is designed to park up to 12 cars using just two ground-level spots, making it the most space-efficient option in tight urban areas.
                </p>
                <p>
                    The system is highly economical, requires low civil work, and is ideal for installations where horizontal expansion is impossible. It’s fast, safe, and operational with just one operator or button interface.
                </p>
            </div>

            {/* Features */}
            <div className="about-section">
                <h2>Key Features & Benefits</h2>
                <ul className="lt-puzzle-list">
                    {features.map((item, index) => (
                        <li key={index}><CheckCircle size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* How it Works */}
            <div className="about-section">
                <h2>How It Works</h2>
                <p>
                    Vehicles are parked on platforms attached to a rotating steel carousel. When a car needs to be parked or retrieved, the system rotates the wheel until the desired slot reaches the ground level. The car is then driven in or out of the platform smoothly.
                </p>
                <p>
                    Safety sensors, anti-fall devices, and auto-locking mechanisms are built into every unit. The system consumes low power and is ideal for outdoor or rooftop installation as well.
                </p>
            </div>

            {/* Applications */}
            <div className="about-section">
                <h2>Best Suited For</h2>
                <ul className="lt-puzzle-list">
                    {applications.map((item, index) => (
                        <li key={index}><Building2 size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* Call to Action */}
            <div className="lt-puzzle-cta">
                <div className="lt-puzzle-cta-content">
                    <h3>Want a Rotary Parking System at your location?</h3>
                    <p>LIFTECH ENGINEERING PVT. LTD. offers precision-built rotary systems ideal for India's urban needs. Contact us today.</p>
                    <button className="lt-puzzle-contact-btn" onClick={() => navigate("/get-started")}>
                        <PhoneCall size={18} /> Request Consultation
                    </button>
                </div>
            </div>
        </section>
    );
};

export default RotaryParkingDetail;
